// tslint:disable: no-bitwise
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'color-converter' })
export class ColorConverterPipe implements PipeTransform {

  pSBCr: any = null;

  /* transform(): Pipe que con vierte un número hexadecimal en HSL y viceversa
    value: Color con formato Hexadecimal "#'nnnnnn'" o formato HSL "('n', 'n', 'n')"
  */
  transform(value: string | number[], type = "hexToHsl"): (string | number)[] {
    // Convert hex to RGB first
    switch (type) {
      // ↓ Convertir de HSL a Hexadecimal
      case "hslToHex": return this.hslToHex(value as number[]);
      // ↓ Convertir de Hexadecimal a HSL
      case "hexToHsl": return this.hexToHsl(value as string);
    }

  }

  // Método que convierte un color con formato Hexadecimal a HSL
  hexToHsl(value: string): number[] {
    // r, g, b Primero se declaran colores con formato RGB
    let [r, g, b]: any[] = [0, 0, 0];
    // ↓↓↓ Se realiza la suma de los hexadecimales correspondientes por cada color primario, ese necesario que el formato hexadecimal contenga los 6 valores
    r = "0x" + value[1] + value[2];
    g = "0x" + value[3] + value[4];
    b = "0x" + value[5] + value[6];
    // ↓ El resultado se divide entre 255
    r /= 255; g /= 255; b /= 255;
    // cmin, cmax Se guardan el menor y mayor valor entre los colores RGB
    const cmin = Math.min(r, g, b);
    const cmax = Math.max(r, g, b);
    // delta: Se general un nuevo valor con la resta del mayor y menor
    const delta = cmax - cmin;
    // h, s, l Se declaran los colores HSL
    let [h, s, l]: any[] = [0, 0, 0];
    if (delta === 0) {
      // ↑ Si 'delta' es 0 entonces la matiz es 0
      h = 0;
    } else if (cmax === r || `${cmax}` === `${r}`) {
      // ↑ Si el valor máximo es el valor del color rojo entonces la matiz se calcula restando los valores de verde y azul divididos entre 'delta' y este resultado se calcula con módulo de 6
      h = ((g - b) / delta) % 6;
    } else if (cmax === g || `${cmax}` === `${g}`) {
      // ↑ Si el valor máximo es el valor del color verde entonces la matiz se calcula restando los valores de azul y rojo divididos entre 'delta' y a este resultado se suman 2 unidades
      h = (b - r) / delta + 2;
    } else { h = (r - g) / delta + 4; }
    // ↑ Si no cumple ninguna condición entonces la matiz se calcula restando los valores de rojo y verde divididos entre 'delta' y a este resultado se suman 4 unidades
    // ↓ La matiz resultante se multiplica por 60 y se redondea
    h = Math.round(h * 60);
    // ↓ Si el resultado de la maztiz es < 0 entonces se agregan 360 unidades
    if (h < 0) { h += 360; }
    // ↓ La luminosidad corresponde al valor intermedio entre el máximo y mínimo
    l = (cmax + cmin) / 2;
    // ↓ Si 'delta' es 0 la saturación es 0, de lo contrario la saturación se calcula dividiendo 'delta' entre 1 menos el valor absoluto de la doble luminosidad y restando 1
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    // ↓↓ Para finalizar el resultado se multiplica entre 100 con un decimal y se convierte a número
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    // ↓ Se retorna el mismo color con formato HSL
    return [h, s, l];
  }

  // Método que convierte un color con formato HSL a Hexadecimal
  hslToHex(value: number[]): string[] {
    // tslint:disable-next-line: prefer-const
    let [h, s, l] = value;
    // ↑ h, s, l, Se crean las variables HSL que corresponden a la lista de valores recibido
    // ↓ La luminosidad y saturación se dividen entre 100
    s /= 100; l /= 100;
    // c: se defina el croma calculando 1 menos el valor absoluto de la doble luminosidad - 1 y el resultado se multiploca con la saturación
    const c = (1 - Math.abs(2 * l - 1)) * s;
    // x: se define el valor intermedio multiplicando el croma con la resta de 1 menos el valor absoluto de la matiz entre 60 modulada en 2 restando 1
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    // m: se guarda la cantidad de componente restando luminosidad con la mitad del croma
    const m = l - c / 2;
    // r, g, b Se definen los colores con formato RGB
    let [r, g, b]: any = [0, 0, 0];
    if (0 <= h && h < 60) {
      // ↑ Si la matiz esta entre 0 y 59, entonces el rojo es igual al croma, el verde es igual al valor intermedio y el azul es 0
      r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
      // ↑ Si la matiz esta entre 60 y 119, entonces el rojo es igual al valor intermedio, el verde es igual al croma y el azul es 0
      r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
      // ↑ Si la matiz esta entre 120 y 179, entonces el rojo es 0, el verde es igual al croma y el azul es igual al valor intermedio
      r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
      // ↑ Si la matiz esta entre 180 y 239, entonces el rojo es 0, el verde es igual al valor intermedio y el azul es igual al croma
      r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
      // ↑ Si la matiz esta entre 240 y 299, entonces el rojo es igual al valor intermedio, el verde es 0 y el azul es igual croma
      r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
      // ↑ Si la matiz esta entre 300 y 359, entonces el rojo es igual al croma, el verde es 0 y el azul es igual al valor intermedio
      r = c; g = 0; b = x;
    }
    // ↓↓↓ Para finalizar por cada color primario se redondea hexadecimalmente el resultado de sumarlo con la cantidad de componente y multiplicar por 255, esto para convertir RGB a HEX
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);
    // ↓ Se retorna el mismo color con formato HEX asegurando que cada color primario tenga 2 valores
    return [("0" + r).slice(-2), ("0" + g).slice(-2), ("0" + b).slice(-2)];
  }

  // https://www.it-swarm.dev/es/javascript/aclarar-o-oscurecer-programaticamente-un-color-hexadecimal-o-rgb-y-combinar-colores/971259188/ Version 4.0
  /* pSBC(): Método que oscurece o aclara un color hexadecimal o rgb
    p: Porcentaje para oscurecer(negativo)/aclarar(positivo)
    c0: Color
    c1: Si el valor es "c", entonces convertira de hex a rgb y visceversa
  */
  pSBC = (p, c0, c1?, l?) => {
    let [r, g, b, P, f, t, h, a] = [null, null, null, null, null, null, null, typeof (c1) === "string"];
    const [i, m] = [parseInt, Math.round];
    if (typeof (p) !== "number" || p < -1 || p > 1 || typeof (c0) !== "string" || (c0[0] !== 'r' && c0[0] !== '#') || (c1 && !a)) { return null; }
    if (!this.pSBCr) {
      this.pSBCr = (d) => {
        let n = d.length;
        const x = {} as any;
        if (n > 9) {
          d = d.split(",");
          [r, g, b, a] = d;
          n = d.length;
          if (n < 3 || n > 4) { return null; }
          x.r = i(r[3] === "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a as any) : -1;
        } else {
          if (+n === 8 || +n === 6 || n < 4) { return null; }
          if (n < 6) { d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : ""); }
          d = i(d.slice(1), 16);
          if (+n === 9 || +n === 5) {
            [x.r, x.g, x.b, x.a] = [d >> 24 & 255, d >> 16 & 255, d >> 8 & 255, m((d & 255) / 0.255) / 1000];
          } else {
            [x.r, x.g, x.b, x.a] = [d >> 16, d >> 8 & 255, d & 255, -1];
          }
        }
        return x;
      };
    }
    h = c0.length > 9;
    h = a ? (c1.length > 9 ? true : (c1 === "c" ? !h : false)) : h;
    f = this.pSBCr(c0);
    P = p < 0;
    t = (c1 && c1 !== "c") ? this.pSBCr(c1) : (P ? ({ r: 0, g: 0, b: 0, a: -1 }) : ({ r: 255, g: 255, b: 255, a: -1 }));
    p = P ? (p * -1) : p;
    P = 1 - p;
    if (!f || !t) { return null; }
    if (l) {
      [r, g, b] = [m(P * f.r + p * t.r), m(P * f.g + p * t.g), m(P * f.b + p * t.b)];
    } else {
      [r, g, b] = [m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), m((P * f.b ** 2 + p * t.b ** 2) ** 0.5)];
    }
    [a, t] = [f.a, t.a];
    f = +a >= 0 || t >= 0;
    a = f ? (+a < 0 ? t : (t < 0 ? a : (+a * P + t * p))) : 0;
    if (h) {
      return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(+a * 1000) / 1000 : "") + ")";
    } else {
      return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(+a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
    }
  }

}
